import React from 'react';
import Tabs from '../ui/Tabs';

export interface WorkspaceTab<K extends string> {
  key: K;
  label: string;
  count?: number;
}

interface WorkspaceTabPillsProps<K extends string> {
  tabs: WorkspaceTab<K>[];
  active: K;
  onSelect: (key: K) => void;
}

/** Seletor de abas em pílulas, para dentro de uma `WorkspaceSection`. Aba com `count` 0 fica desabilitada. */
function WorkspaceTabPills<K extends string>({ tabs, active, onSelect }: WorkspaceTabPillsProps<K>) {
  return (
    <div className="border-t border-line px-5 py-3">
      <Tabs variant="pills" ariaLabel="Filtrar a seção" tabs={tabs} active={active} onChange={onSelect} />
    </div>
  );
}

export default WorkspaceTabPills;
